var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MIN_GUIDE_BOX_COVERAGE_RATIO = 0.7;
var MAX_GUIDE_BOX_OVERFLOW_RATIO = 1.4;
var MAX_ASPECT_RATIO_DEVIATION_RATIO = 0.35;
var CENTER_OFFSET_THRESHOLD_RATIO = 0.15;
var CROP_PADDING_RATIO = 0.6;
export function getCropRegion(guideBox, frameWidth, frameHeight) {
    var padX = guideBox.width * CROP_PADDING_RATIO;
    var padY = guideBox.height * CROP_PADDING_RATIO;
    var x = Math.max(0, guideBox.x - padX);
    var y = Math.max(0, guideBox.y - padY);
    var width = Math.max(0, Math.min(frameWidth - x, guideBox.width + padX * 2));
    var height = Math.max(0, Math.min(frameHeight - y, guideBox.height + padY * 2));
    return { x: x, y: y, width: width, height: height };
}
export function findDocumentContour(scanner, sourceCanvas, cropRegion) {
    return __awaiter(this, void 0, void 0, function () {
        var cropCanvas, cropCtx, result, _a, topLeft, topRight, bottomLeft, bottomRight;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (cropRegion.width <= 0 || cropRegion.height <= 0) {
                        return [2 /*return*/, null];
                    }
                    cropCanvas = document.createElement('canvas');
                    cropCanvas.width = cropRegion.width;
                    cropCanvas.height = cropRegion.height;
                    cropCtx = cropCanvas.getContext('2d');
                    if (!cropCtx) {
                        return [2 /*return*/, null];
                    }
                    cropCtx.drawImage(sourceCanvas, cropRegion.x, cropRegion.y, cropRegion.width, cropRegion.height, 0, 0, cropRegion.width, cropRegion.height);
                    return [4 /*yield*/, scanner.scan(cropCanvas, { mode: 'detect' })];
                case 1:
                    result = _b.sent();
                    if (!result.success || !result.corners) {
                        return [2 /*return*/, null];
                    }
                    _a = result.corners, topLeft = _a.topLeft, topRight = _a.topRight, bottomLeft = _a.bottomLeft, bottomRight = _a.bottomRight;
                    return [2 /*return*/, {
                            topLeftCorner: { x: topLeft.x + cropRegion.x, y: topLeft.y + cropRegion.y },
                            topRightCorner: { x: topRight.x + cropRegion.x, y: topRight.y + cropRegion.y },
                            bottomLeftCorner: { x: bottomLeft.x + cropRegion.x, y: bottomLeft.y + cropRegion.y },
                            bottomRightCorner: { x: bottomRight.x + cropRegion.x, y: bottomRight.y + cropRegion.y },
                        }];
            }
        });
    });
}
function boundingBoxOf(corners) {
    var xs = [corners.topLeftCorner.x, corners.topRightCorner.x, corners.bottomLeftCorner.x, corners.bottomRightCorner.x];
    var ys = [corners.topLeftCorner.y, corners.topRightCorner.y, corners.bottomLeftCorner.y, corners.bottomRightCorner.y];
    var minX = Math.min.apply(Math, xs);
    var maxX = Math.max.apply(Math, xs);
    var minY = Math.min.apply(Math, ys);
    var maxY = Math.max.apply(Math, ys);
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
export function describeFraming(corners, guideBox) {
    var detected = boundingBoxOf(corners);
    var guideBoxArea = guideBox.width * guideBox.height;
    var detectedArea = detected.width * detected.height;
    if (guideBoxArea === 0) {
        return { wellFramed: false, adjustment: 'adjust' };
    }
    var areaRatio = detectedArea / guideBoxArea;
    if (areaRatio < MIN_GUIDE_BOX_COVERAGE_RATIO) {
        return { wellFramed: false, adjustment: 'move-closer' };
    }
    if (areaRatio > MAX_GUIDE_BOX_OVERFLOW_RATIO) {
        return { wellFramed: false, adjustment: 'move-farther' };
    }
    var detectedCenterX = detected.x + detected.width / 2;
    var detectedCenterY = detected.y + detected.height / 2;
    var guideBoxCenterX = guideBox.x + guideBox.width / 2;
    var guideBoxCenterY = guideBox.y + guideBox.height / 2;
    var offsetXRatio = (detectedCenterX - guideBoxCenterX) / guideBox.width;
    var offsetYRatio = (detectedCenterY - guideBoxCenterY) / guideBox.height;
    if (Math.abs(offsetXRatio) > CENTER_OFFSET_THRESHOLD_RATIO || Math.abs(offsetYRatio) > CENTER_OFFSET_THRESHOLD_RATIO) {
        if (Math.abs(offsetXRatio) >= Math.abs(offsetYRatio)) {
            return { wellFramed: false, adjustment: offsetXRatio > 0 ? 'move-left' : 'move-right' };
        }
        return { wellFramed: false, adjustment: offsetYRatio > 0 ? 'move-up' : 'move-down' };
    }
    var detectedAspectRatio = detected.width / detected.height;
    var guideBoxAspectRatio = guideBox.width / guideBox.height;
    var aspectRatioDeviation = Math.abs(detectedAspectRatio - guideBoxAspectRatio) / guideBoxAspectRatio;
    if (aspectRatioDeviation > MAX_ASPECT_RATIO_DEVIATION_RATIO) {
        return { wellFramed: false, adjustment: 'adjust' };
    }
    var intersectionX = Math.max(0, Math.min(detected.x + detected.width, guideBox.x + guideBox.width) - Math.max(detected.x, guideBox.x));
    var intersectionY = Math.max(0, Math.min(detected.y + detected.height, guideBox.y + guideBox.height) - Math.max(detected.y, guideBox.y));
    var coverageRatio = (intersectionX * intersectionY) / guideBoxArea;
    if (coverageRatio < MIN_GUIDE_BOX_COVERAGE_RATIO) {
        if (Math.abs(offsetXRatio) >= Math.abs(offsetYRatio)) {
            return { wellFramed: false, adjustment: offsetXRatio > 0 ? 'move-left' : 'move-right' };
        }
        return { wellFramed: false, adjustment: offsetYRatio > 0 ? 'move-up' : 'move-down' };
    }
    return { wellFramed: true, adjustment: null };
}
export function computeMotionScore(previousSample, currentSample) {
    if (!previousSample || previousSample.length !== currentSample.length) {
        return 0;
    }
    var totalDifference = 0;
    var pixelCount = currentSample.length / 4;
    for (var i = 0; i < currentSample.length; i += 4) {
        var previousGray = previousSample[i] * 0.299 + previousSample[i + 1] * 0.587 + previousSample[i + 2] * 0.114;
        var currentGray = currentSample[i] * 0.299 + currentSample[i + 1] * 0.587 + currentSample[i + 2] * 0.114;
        totalDifference += Math.abs(currentGray - previousGray);
    }
    return totalDifference / pixelCount;
}
export default {
    getCropRegion: getCropRegion,
    findDocumentContour: findDocumentContour,
    describeFraming: describeFraming,
    computeMotionScore: computeMotionScore,
};
